<template>
  <div class="page">
    <div class="banner">
      <img :src="bannerImg">
      <div class="title">操作教程</div>
    </div>
    <div class="video-list">
      <div class="video-container" v-for="item in tableData">
        <video
          class="video"
          controls
          :poster="item.image"
          controlslist="nodownload"
          οncοntextmenu='return false'
          @play="hidePoster"
          @pause="showPoster"
          @error="showPoster"
        >
          <source :src="item.video" type="video/mp4" />
        </video>
        <div class="video-title">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request"

export default {
  name: "evaluationDetail",
  data () {
    return {
      fullscreenLoading: false,
      bannerImg: '',
      tableData:[]
    }
  },
  methods: {
    getBanner () {
      this.fullscreenLoading = true
      request({
        method: 'get',
        url: '/index/getBanner',
        params: {
          type: 7
        }
      }).then(res => {
        this.fullscreenLoading = false
        if (![0, 200].includes(res.code)) {
          return this.$message.error(res.msg)
        }
        if (res.data[0]) {
          this.bannerImg = res.data[0].image
        }
      }).catch((res) => {
      });
    },
    getTutorialInfo () {
      this.fullscreenLoading = true
      request({
        method: 'get',
        url: '/open/tutorial/list',
        params: {
          type: this.$route.meta.reqType,
          isLogin: this.$route.meta.reqIsLogin
        }
      }).then(res => {
        this.tableData = res.data
      }).catch((res) => {
      });
    },
    hidePoster() {
      this.showPoster = false;
    },
    showPoster() {
      this.showPoster = true;
    },
  },
  created () {
    this.getBanner();
    this.getTutorialInfo();
  }
}
document.oncontextmenu = function(){
  event.returnValue = false;
}// 或者直接返回整个事件
document.oncontextmenu = function(){
  return false;
}
</script>

<style scoped lang="stylus">
.video-container .video-poster[show] {
  opacity: 1;
}
.page
  font-size 15px
  background #F9F9F9
  width 100%
  .banner
    position: relative;
    width: 100%;
    height: 260px;
    img
      display: block;
      width: 100%;
      height: 100%;
      -o-object-fit: cover;
      object-fit: cover;
    .title
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -43px;
      margin-left: -100px;
      z-index: 1;
      width: 200px;
      height: 86px;
      font-size: 50px;
      //font-weight: PingFangMedium600;
      color: #FFFFFF;
      line-height: 86px;
      text-shadow: 0 4px 4px rgba(121,68,2,0.1);
  .video-list
    width 1440px
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    background: #fff;
    .video-container
      width: 20%;
      padding-top: 18px;
      padding-left: 58px;
      position relative
      .video
        width: 100%;
      .video-poster
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0;
        pointer-events: none;
      .video-title
        margin-bottom: 5px;
        text-align: center;
        font-weight: bold;

&-bd
    width 1440px
    margin 10px auto 60px auto
    // uiBlock()
    // padding 32px 22px 39px 22px
    box-sizing border-box


.contact-item + .contact-item
  margin-left: 50px;
</style>
